import styled from 'styled-components';
import Backdrop, { defaultPadding } from 'js/components/core/Backdrop';
import { verticalPadding, lineHeight } from 'js/components/common/Button/style';

export default styled(Backdrop)`
  padding-top: ${`calc(${defaultPadding} - ${(verticalPadding + lineHeight) / 2}rem)`};
  padding-bottom: 0;
`;
